export const EXCEPTION_SALE_TYPE_LIST = new Set([
  'RETAIL',
  'DROP_SHIPPING',
  'PRODUCT_BRAND_FASHION',
  'PRODUCT_PROMOTION',
  'PRODUCT_OVERSEA',
  'PRODUCT_OVERSEA_PAY_ON_SCAN',
]);
